import * as React from 'react';
export const IcBiology = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.85 3.47A1 1 0 0020 3h-6C7.21 3 3 7.6 3 15c0 2.81.73 4.33 1.63 5.13A.25.25 0 005 20c.33-6 3.54-10.29 9.57-12.87a1 1 0 11.78 1.84C9.83 11.3 7.09 15.17 7 20.73a.28.28 0 00.27.27C16 20.9 20 15.77 20 11c0-4.59.88-6.51.9-6.56a1 1 0 00-.05-.97z'
      fill='currentColor'
    />
  </svg>
);
